export const isScreenLandscape = (screenOrientation: OrientationType) =>
    screenOrientation === 'landscape-primary' || screenOrientation === 'landscape-secondary';
